module.exports = __webpack_public_path__ + "images/temporary/viking-hero-main.svg";